import { Injectable, isDevMode } from '@angular/core';
import CookieOptions from '@core/models/system/cookie.model';

@Injectable({
  providedIn: 'root',
})
export class Cookie {
  setCookie(name: string, value: string, days: number): void;
  setCookie(name: string, value: string, options?: CookieOptions): void;
  setCookie(
    name: string,
    value: string,
    daysOrOptions?: number | CookieOptions,
  ): void {
    let days = 7;
    let sameSite: 'Strict' | 'Lax' | 'None' = 'Strict';
    let secure = !isDevMode();

    if (typeof daysOrOptions === 'number') {
      days = daysOrOptions;
    } else if (daysOrOptions) {
      days = daysOrOptions.days ?? days;
      sameSite = daysOrOptions.sameSite ?? sameSite;
      secure = daysOrOptions.secure ?? secure;
    }

    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    const parts = [
      `${name}=${value}`,
      `expires=${expires.toUTCString()}`,
      'path=/',
      `SameSite=${sameSite}`,
    ];
    if (secure) {
      parts.push('Secure');
    }
    document.cookie = parts.join(';');
  }

getCookie(name: string): string | null {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');

  for (let c of ca) {
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }

  return null;
}

  deleteCookie(name: string): void {
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Strict${isDevMode() ? '' : ';Secure'}`;
  }
}
